import React from "react";
import { User } from "../../entities/interfaces/users";
import { Button, Table, Tag } from "antd";
import { Store } from "../../entities/interfaces/stores";
import dayjs from "dayjs";

type Props = {
  stores: Store[];
  onSelect: (store: Store) => void;
};

const StoreList = ({ stores, onSelect }: Props) => {
  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Address",
      dataIndex: "address",
      key: "address",
    },
    {
      title: "City",
      key: "city",
      render: (record: Store) => (
        <p>
          {record.city} {record.state}
        </p>
      ),
    },
    {
      title: "Opening Time",
      key: "openingTime",
      render: (record: Store) => (
        <p>{dayjs(record.openingTime).format("HH:mm A")}</p>
      ),
    },
    {
      title: "Closing Time",
      key: "closingTime",
      render: (record: Store) => (
        <p>{dayjs(record.closingTime).format("HH:mm A")}</p>
      ),
    },
    {
      title: "Action",
      key: "action",
      render: (record: any) => {
        return (
          <Button size="small" onClick={() => onSelect(record)}>
            Update
          </Button>
        );
      },
    },
  ];

  return <Table dataSource={stores} columns={columns} />;
};

export default StoreList;
